import { defineFreeTextFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const nameDescriptor = defineFreeTextFilter({
  definition: {
    id: FilterId.NAME,
    name: 'Name',
    text: [],
    type: FilterType.FREE_TEXT,
    isVisible: true,
  },
});
